import type { TFunction } from 'i18next';
import type { CreateSlipResult } from 'services/api/slipService';

const CURRENCY = process.env.REACT_APP_CURRENCY ?? '';

/**
 * The player's message for a slip the risk rules held back
 * (tottalo_api internal/risk), or null when the result is something else.
 * The wording stays friendly: where a smaller stake is still taken the
 * player is told how much.
 */
export const slipRiskMessage = (
  result: CreateSlipResult,
  t: TFunction
): string | null => {
  if (result.ok || !result.code) return null;
  const match = result.match ?? '';
  switch (result.code) {
    case 'risk_max_stake':
      return t('risk_max_stake_message', {
        amount: (result.maxStake ?? 0).toFixed(2),
        currency: CURRENCY,
      });
    case 'risk_outcome_closed':
      return match
        ? t('risk_outcome_closed_match_message', { match })
        : t('risk_outcome_closed_message');
    case 'risk_live_blocked':
      return t('risk_live_blocked_message');
    case 'approval_waiting':
      return t('approval_waiting_message');
    case 'approval_rejected':
      return result.reason
        ? t('approval_rejected_reason_message', { reason: result.reason })
        : t('approval_rejected_message');
    case 'approval_expired':
      return t('approval_expired_message');
    case 'approval_cancelled':
      return t('approval_cancelled_message');
    case 'recheck_score_changed':
      return t('recheck_score_changed_message', { match });
    case 'recheck_odds_changed':
      return t('recheck_odds_changed_message', { match });
    case 'recheck_match_started':
      return t('recheck_match_started_message', { match });
    case 'recheck_pick_closed':
      return t('recheck_pick_closed_message', { match });
  }
  return null;
};

/** Shown when staff took the ticket at a lower stake. */
export const approvedStakeMessage = (stake: number, t: TFunction) =>
  t('approval_lower_stake_message', {
    amount: stake.toFixed(2),
    currency: CURRENCY,
  });
